/**
 * The next day the country's distance to Denmark changes (15/10/2026 — the
 * Danish clock): from then on a Danish time lands an hour earlier or later
 * in the country. Either country's clock change counts (Sydney 04/10 and
 * 05/04, Denmark 25/10 and 28/03). Looked up day by day, a year ahead.
 * For Media Devoted | Created By Ciro Autiero
 */
import { addDaysIso, wallTimeToUtc } from "../wall-clock";
import { cphDeltaMin } from "./danish-clock";

export interface ClockChange {
  /** The country's first run date on the new distance. */
  runDate: string;
  /** Country minus Denmark, in minutes, before and from that day. */
  beforeMin: number;
  afterMin: number;
}

const deltaOn = (tz: string, runDate: string) =>
  cphDeltaMin(tz, wallTimeToUtc({ dateIso: runDate, minutesFromMidnight: 720, tz }));

export function nextClockChange(tz: string | null, fromRunDate: string): ClockChange | null {
  if (!tz) return null;
  const beforeMin = deltaOn(tz, fromRunDate);
  for (let d = 1; d <= 366; d += 1) {
    const runDate = addDaysIso(fromRunDate, d);
    const afterMin = deltaOn(tz, runDate);
    if (afterMin !== beforeMin) return { runDate, beforeMin, afterMin };
  }
  return null;
}
